<template>
  <svg
    xmlns:svg="http://www.w3.org/2000/svg"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    width="100%"
    height="100%"
    viewBox="0 0 36 36"
    preserveAspectRatio="none"
    id="pipeline_90_leftup"
    style="z-index: 1"
  >
    <title>{{ hint }}</title>
    <defs>
      <radialGradient fx="48" fy="48" cx="32" cy="32" r="36" gradientUnits="userSpaceOnUse" id="lu-KeyGradient">
         <stop style="stop-opacity:1;stop-color:#3b3838" offset="0.24" />
         <stop style="stop-opacity:1;stop-color:#dedede" offset="0.69" />
         <stop style="stop-opacity:1;stop-color:#99a1af " offset="0.88" />
      </radialGradient>
      
        <!--https://tailwindcss.com/docs/colors gray-->
      <radialGradient fx="48" fy="48" cx="32" cy="32" r="36" gradientUnits="userSpaceOnUse" id="lu-OilGradient">
        <stop style="stop-opacity: 1; stop-color: #868485 " offset="0.24"/>
        <stop style="stop-opacity: 1; stop-color: #99a1af" offset="0.69" />
        <stop style="stop-opacity: 1; stop-color: #868485 " offset="0.88" />
      </radialGradient>
      <path id="lu-main" d="m 0  36 L 24  36 C 24 28 28 24 36 24  L 36 0  C 12 0  0  12  0 36Z" />
    </defs>
    <g :visibility="fState[0]">
      <use href="#lu-main" fill="url(#lu-KeyGradient)" />
    </g>
    <g :visibility="fState[1]">
      <use href="#lu-main" fill="url(#lu-OilGradient)" />
    </g>
    <g :visibility="fState[2]">
      <use href="#lu-main" fill="url(#lu-KeyGradient)" />
    </g>
    <g :visibility="fState[3]">
      <use href="#lu-main" fill="url(#lu-KeyGradient)" />
    </g>
    <g :visibility="fState[4]">
      <use href="#lu-main" fill="url(#lu-KeyGradient)" />
    </g>
    <g :visibility="fState[5]">
      <use href="#lu-main" fill="url(#lu-KeyGradient)" />
    </g>
    <g :visibility="fState[10]">
      <use href="#lu-main" fill="url(#lu-KeyGradient)" />
    </g>
  </svg>
</template>

<script>
import MixinStates from "./mixin-states.js";

export default {
  name: "pipeline_90_leftup",
  mixins: [MixinStates],
};
</script>
